import { render, staticRenderFns } from "./IsolationIndex.vue?vue&type=template&id=002a00ce&scoped=true&"
import script from "./IsolationIndex.vue?vue&type=script&lang=js&"
export * from "./IsolationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a00ce",
  null
  
)

export default component.exports